import { twMerge } from "tailwind-merge";

import SmsSimulatorPersonaBadge from "containers/sms-simulator/sms-simulator-simulator/components/simulated-sms-card/sms-simulator-persona-badge";

import {
  SmsSimulatorPersonaAttributes,
  SmsMessage,
} from "containers/sms-simulator/sms-simulator.types";

interface SmsSimulatorSimulationCardProps extends React.HTMLAttributes<HTMLDivElement> {
  personaBadgeProps: SmsSimulatorPersonaAttributes;
  conversation: SmsMessage[];
}

const SmsSimulatorSimulationCard = ({
  personaBadgeProps,
  conversation,
  ...rest
}: SmsSimulatorSimulationCardProps) => {
  const renderMessage = (message: SmsMessage, index: number) => {
    const isPersonaMessage = message.senderId === personaBadgeProps.id;

    let borderRadiusClasses = "";
    if (isPersonaMessage) {
      borderRadiusClasses = "rounded-2xl rounded-tl-none";
    } else {
      borderRadiusClasses = "rounded-2xl rounded-tr-none";
    }

    return (
      <div
        key={`${message.senderId}-${index}`}
        className={twMerge(
          "text-md border p-2 mt-1.5",
          isPersonaMessage ? "bg-aqua-50" : "bg-gray-100",
          borderRadiusClasses,
        )}>
        {message.content}
      </div>
    );
  };

  return (
    <div className="flex flex-col bg-white w-[316px] rounded-md p-4 border border-gray-200">
      <SmsSimulatorPersonaBadge persona={personaBadgeProps} />
      <div className="flex flex-col">
        {conversation && conversation.length > 0 ? (
          conversation.map((message, index) => renderMessage(message, index))
        ) : (
          <div className="flex items-center justify-center py-8 px-4 text-center">
            <div className="text-gray-500">
              <p className="text-sm font-medium">No messages available</p>
              <p className="text-xs mt-1">This simulation may have failed to generate messages</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SmsSimulatorSimulationCard;
